<div class="loading-spinner" *ngIf="!photoToUploadUrl || !logo; else branding">
  <div class="cc-icon cc-icon-spinner"></div>
</div>

<ng-template #branding>
  <h1 class="sm-pb-4 sm-text-xl sm-font-medium" i18n>Branding</h1>
  <div class="row sm-pb-4">
    <div class="col-sm-4" i18n>
      <span>Logo</span>
    </div>
    <div class="col-sm-8 d-flex align-items-start flex-column">
      <img [src]="photoToUploadUrl || logo" class="company-logo" alt="company logo" />
      <div class="sm-flex sm-items-center">
        <label
          i18n
          class="default-label sm-my-2 rounded sm-cursor-pointer sm-p-2 cc-btn-subtle-blue font-weight-medium"
          [class.disabled]="isUploading || !hasEditPermission"
        >
          Choose file
          <input
            data-test="file-input"
            type="file"
            name="file"
            class="d-none"
            (change)="onPhotoSelected($event)"
            accept="image/jpeg, image/png"
            [disabled]="isUploading || !hasEditPermission"
          />
        </label>
        <i
          class="cc-icon cc-icon-question sm-ml-2"
          [ngbPopover]="logoTooltip"
          popoverClass="label-popover"
          placement="right"
          triggers="mouseenter:mouseleave"
          container="body"
          data-test="logo-tooltip"
        ></i>
      </div>
      <ng-template #logoTooltip>
        <div i18n id="logoTooltip">
          Logo must be:
          <ul class="sm-list-disc sm-ml-4">
            <li>Less than 5MB</li>
            <li>Greater than 100x100 pixels</li>
            <li>Either a JPG, JPEG, PNG or BMP file</li>
          </ul>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="row sm-pb-4">
    <div class="col-sm-4" i18n>
      <span>Brand colour</span>
    </div>
    <div class="col-sm-8 form-inline">
      <span *ngIf="!isEditColor" class="color-box" [style.background-color]="color"></span>
      <div class="color-picker-container" *ngIf="isEditColor">
        <input class="form-control rounded-0 color-picker-input" [(ngModel)]="color" />
        <span
          [(colorPicker)]="color"
          [cpPosition]="'bottom'"
          [cpPositionOffset]="'50%'"
          [cpPositionRelativeToArrow]="true"
          [style.background-color]="color"
          class="color-picker sm-self-start"
        ></span>
      </div>
      <button
        type="button"
        *ngIf="!isEditColor"
        class="sm-ml-2 btn btn-sm color-picker-button"
        data-test="edit-color"
        (click)="editColor()"
        [disabled]="!hasEditPermission"
      >
        <i class="cc-icon cc-icon-pencil"></i>
      </button>
      <div *ngIf="isEditColor" class="ml-3">
        <button
          type="button"
          class="btn btn-secondary btn-sm"
          data-test="color-picker-done"
          (click)="onColorSelected()"
          i18n
          [disabled]="isUploading"
        >
          Done <i class="cc-icon cc-icon-spinner-lg" *ngIf="isUploading"></i>
        </button>
        <small>
          <a class="ml-3 link" data-test="cancel-editor" (click)="cancelEditColor()" i18n> Cancel </a>
        </small>
      </div>
    </div>
  </div>
  <div class="sm-text-left" i18n>
    <button
      type="submit"
      data-test="save-button"
      class="sm-p-2 sm-rounded button-green"
      [class.disabled]="!canSaveSettings || !hasEditPermission"
      (click)="onSave()"
    >
      Save changes <i class="cc-icon cc-icon-spinner-lg" *ngIf="isUploading"></i>
    </button>
  </div>
</ng-template>
